(() => {
  if (window.__athomeCollectionLoaded) return;
  window.__athomeCollectionLoaded = true;

  const mapRoot = document.querySelector('[data-ath-collection-image-map]');
  const imageMap = new Map(
    [...(mapRoot?.querySelectorAll('[data-ath-product-handle]') || [])].map((item) => [
      item.dataset.athProductHandle,
      { src: item.dataset.athProductImage, alt: item.dataset.athProductAlt }
    ])
  );

  const withWidth = (src, width) => `${src}${src.includes('?') ? '&' : '?'}width=${width}`;
  const installCollectionLinkSortGuard = () => {
    if (document.documentElement.dataset.athCollectionLinkGuard === 'true') return;
    document.documentElement.dataset.athCollectionLinkGuard = 'true';
    document.addEventListener('click', (event) => {
      const link = event.target.closest?.('a[href]');
      if (!link) return;
      let url;
      try {
        url = new URL(link.href, window.location.origin);
      } catch (_error) {
        return;
      }
      if (url.origin !== window.location.origin || !/^\/collections\/[^/]+/.test(url.pathname)) return;
      let changed = false;
      if (!url.searchParams.has('sort_by')) {
        url.searchParams.set('sort_by', 'best-selling');
        changed = true;
      }
      if (activeTaxonomyContext && url.pathname === window.location.pathname && !url.searchParams.has('collection_context')) {
        url.searchParams.set('collection_context', activeTaxonomyContext);
        changed = true;
      }
      if (changed) link.href = url.toString();
    }, true);
  };
  const preferredSortOptions = new Map([
    ['best-selling', 'Best selling'],
    ['price-ascending', 'Price: Low to high'],
    ['price-descending', 'Price: High to low'],
    ['created-descending', 'Newest']
  ]);
  const collectionTaxonomy = {
    catheters: {
      label: 'Catheters',
      root: '/collections/intermittent-catheters',
      match: /catheter|drainage|collection-bags|belly-bags|leg-bags|lubricat|male-urinals|penile-clamps|sterile-saline|urocare|wellspect|cure-medical|hr-catheters|bard-medical|teleflex-rusch|coloplast-catheters|mtg/,
      childLabel: 'Catheter types',
      children: [
        ['Intermittent Catheters', '/collections/intermittent-catheters'],
        ['Closed System Catheters', '/collections/closed-system-catheters'],
        ['External Catheters', '/collections/external-catheters'],
        ['Foley Catheters', '/collections/foley-indwelling-catheters'],
        ['Collection Bags', '/collections/collection-bags'],
        ['Lubricant', '/collections/lubricating-jelly']
      ],
      brands: [
        ['Cure Medical', '/collections/cure-medical-catheters'],
        ['Coloplast', '/collections/coloplast-catheters'],
        ['Bard Medical', '/collections/bard-medical-bd'],
        ['HR Healthcare', '/collections/hr-catheters'],
        ['Teleflex-Rusch', '/collections/teleflex-rusch-urological'],
        ['Hollister', '/collections/hollister'],
        ['ConvaTec', '/collections/convectec'],
        ['Wellspect', '/collections/wellspect-catheters']
      ]
    },
    incontinence: {
      label: 'Incontinence',
      root: '/collections/incontinence',
      match: /incontinence|briefs-underwear|adult-briefs|adult-protective-underwear|underpads|female-liners-pads|male-guards|wipes-1|odor-eliminators|attends|prevail|presto|first-quality|tena|tranquility/,
      childLabel: 'Incontinence products',
      children: [
        ['Adult Briefs', '/collections/adult-briefs'],
        ['Protective Underwear', '/collections/adult-protective-underwear'],
        ['Disposable Underpads', '/collections/disposable-underpads'],
        ['Reusable Underpads', '/collections/reusable-underpads'],
        ['Liners & Pads', '/collections/female-liners-pads'],
        ['Wipes', '/collections/wipes-1']
      ],
      brands: [
        ['Prevail', '/collections/prevail'],
        ['Presto', '/collections/presto-adult-incontinence'],
        ['TENA', '/collections/tena'],
        ['Tranquility', '/collections/tranquility'],
        ['Attends', '/collections/attends'],
        ['First Quality', '/collections/first-quality'],
        ['Medline', '/collections/medline'],
        ['Cardinal Health', '/collections/cardinal-health']
      ]
    },
    bowel: {
      label: 'Bowel Care',
      root: '/collections/bowel-management',
      match: /bowel-management|suppositories|enemeez|the-magic-bullet/,
      childLabel: 'Bowel care products',
      children: [
        ['Bowel Care', '/collections/bowel-management'],
        ['Suppositories', '/collections/suppositories'],
        ['Lubricant', '/collections/lubricating-jelly'],
        ['Enemeez', '/collections/enemeez']
      ],
      brands: [
        ['Enemeez', '/collections/enemeez'],
        ['Medline', '/collections/medline']
      ]
    },
    skin: {
      label: 'Skin Care',
      root: '/collections/skin-care',
      match: /skin-care|skin-cleansers|lotions|skin-prep|skin-protectants|povidone|bzkwipes|tape/,
      childLabel: 'Skin care products',
      children: [
        ['Cleansers', '/collections/skin-cleansers-ointments'],
        ['Lotions', '/collections/lotions'],
        ['Skin Prep Wipes', '/collections/skin-prep-wipes'],
        ['Skin Protectants', '/collections/skin-protectants'],
        ['BZK Wipes', '/collections/bzkwipes'],
        ['Tape', '/collections/tape']
      ],
      brands: [
        ['3M', '/collections/3m'],
        ['Medline', '/collections/medline'],
        ['Smith and Nephew', '/collections/smith-and-nephew'],
        ['Dynarex', '/collections/dynarex']
      ]
    },
    daily: {
      label: 'Daily Living',
      root: '/collections/aids-for-daily-living',
      match: /aids-for-daily-living|bath-bench|personal-protection|pill-containers|reachers|rollators|toothbrushes|posey/,
      childLabel: 'Daily living products',
      children: [],
      brands: [
        ['Medline', '/collections/medline'],
        ['Cardinal Health', '/collections/cardinal-health'],
        ['Dynarex', '/collections/dynarex']
      ]
    },
    gloves: {
      label: 'Exam Gloves',
      root: '/collections/exam-gloves',
      match: /exam-gloves|latex-gloves|nitrile-gloves|vinyl-gloves|shamrock/,
      childLabel: 'Glove types',
      children: [
        ['Exam Gloves', '/collections/exam-gloves'],
        ['Latex Gloves', '/collections/latex-gloves'],
        ['Nitrile Gloves', '/collections/nitrile-gloves']
      ],
      brands: [
        ['Medline', '/collections/medline'],
        ['Dynarex', '/collections/dynarex'],
        ['Cardinal Health', '/collections/cardinal-health']
      ]
    },
    ostomy: {
      label: 'Ostomy',
      root: '/collections/ostomy-supplies',
      match: /ostomy|adapt-paste|adhesive-remover|barrier-creams|barrier-wipes/,
      childLabel: 'Ostomy products',
      children: [
        ['Ostomy Supplies', '/collections/ostomy-supplies'],
        ['Liquid Adhesive & Paste', '/collections/adapt-paste'],
        ['Adhesive Remover Spray', '/collections/adhesive-remover-spray'],
        ['Adhesive Remover Wipes', '/collections/adhesive-remover-wipes-1'],
        ['Barrier Wipes', '/collections/barrier-wipes']
      ],
      brands: [
        ['Coloplast', '/collections/coloplast-ostomy'],
        ['Hollister', '/collections/hollister-ostomy']
      ]
    }
  };
  const globalBrandLinks = [
    ['Cure Medical', '/collections/cure-medical-catheters'],
    ['Coloplast', '/collections/coloplast-catheters'],
    ['Bard Medical', '/collections/bard-medical-bd'],
    ['HR Healthcare', '/collections/hr-catheters'],
    ['Teleflex-Rusch', '/collections/rusch-flocath-quick-catheters'],
    ['Hollister', '/collections/hollister'],
    ['ConvaTec', '/collections/convectec'],
    ['Wellspect', '/collections/wellspect-catheters'],
    ['MTG', '/collections/mtg'],
    ['Amsino', '/collections/amsino'],
    ['Medline', '/collections/medline'],
    ['Prevail', '/collections/prevail']
  ];
  const taxonomyEntries = Object.entries(collectionTaxonomy);
  const currentCollectionHandle = document.querySelector('[data-ath-collection-handle]')?.dataset.athCollectionHandle || '';
  const requestedContextKey = new URL(window.location.href).searchParams.get('collection_context');
  const requestedContext = requestedContextKey ? collectionTaxonomy[requestedContextKey] : null;
  const activeTaxonomyContext = requestedContext ? requestedContextKey : null;
  const globalBrandHandles = new Set(globalBrandLinks.map(([, href]) => href.split('/').filter(Boolean).pop()));
  const genericBrandTaxonomy = {
    label: 'Brands',
    root: '/collections',
    childLabel: 'Popular brands',
    children: globalBrandLinks,
    brands: []
  };
  const genericCollectionTaxonomy = {
    label: 'Categories',
    root: '/collections',
    childLabel: 'Popular collections',
    children: [
      ['Featured Products', '/collections/featured-products'],
      ['All Collections', '/collections']
    ],
    brands: globalBrandLinks
  };
  const matchedTaxonomyEntry = taxonomyEntries.find(([, group]) => group.match.test(currentCollectionHandle));
  const currentTaxonomyEntry = requestedContext
    ? [requestedContextKey, requestedContext]
    : globalBrandHandles.has(currentCollectionHandle)
      ? ['brands', genericBrandTaxonomy]
      : matchedTaxonomyEntry || ['categories', genericCollectionTaxonomy];
  const [currentTaxonomyKey, currentTaxonomy] = currentTaxonomyEntry;
  const primaryCategoryLinks = taxonomyEntries.map(([, group]) => [group.label, group.root, group === currentTaxonomy]);
  const contextualizeTaxonomyHref = (href) => {
    const url = new URL(href, window.location.origin);
    url.searchParams.set('sort_by', 'best-selling');
    if (!['brands', 'categories'].includes(currentTaxonomyKey)) {
      url.searchParams.set('collection_context', currentTaxonomyKey);
    }
    return `${url.pathname}${url.search}${url.hash}`;
  };
  const childLinks = currentTaxonomy.children.map(([label, href]) => [label, contextualizeTaxonomyHref(href)]);
  const brandLinks = currentTaxonomy.brands.map(([label, href]) => [label, contextualizeTaxonomyHref(href)]);
  const ensureTaxonomyContextInputs = (scope = document) => {
    if (!activeTaxonomyContext) return;
    const forms = scope.querySelectorAll?.('form#FacetFiltersForm, form#FacetFiltersFormMobile') || [];
    scope.querySelectorAll?.('form#FacetSortForm input[name="collection_context"]')?.forEach((input) => input.remove());
    forms.forEach((form) => {
      let input = form.querySelector('input[name="collection_context"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'collection_context';
        form.append(input);
      }
      input.value = activeTaxonomyContext;
    });
  };
  const handleFromHref = (href) => {
    try {
      const match = new URL(href, window.location.origin).pathname.match(/\/products\/([^/?#]+)/);
      return match ? match[1] : '';
    } catch (_error) {
      return '';
    }
  };

  const setMobileFacetScrollLock = (locked) => {
    [document.documentElement, document.body].forEach((root) => {
      root.classList.toggle('overflow-hidden-mobile', locked);
      if (!locked) root.style.removeProperty('overflow');
    });
  };

  const closeMobileFacetSheet = () => {
    document.querySelectorAll('menu-drawer.mobile-facets__wrapper').forEach((drawer) => {
      const details = drawer.querySelector(':scope > details');
      const summary = details?.querySelector(':scope > summary');
      if (!details?.open) return;
      details.open = false;
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
      summary?.setAttribute('aria-expanded', 'false');
    });
    setMobileFacetScrollLock(false);
  };

  const mobileFacetUrl = (drawer, clearLink = null) => {
    const url = clearLink
      ? new URL(clearLink.href, window.location.origin)
      : new URL(window.location.href);

    if (!clearLink) {
      [...url.searchParams.keys()].forEach((key) => {
        if (key.startsWith('filter.') || key === 'page') url.searchParams.delete(key);
      });

      repairMobileAvailabilityValues(drawer);
      drawer.querySelectorAll('input[name^="filter."]:checked').forEach((input) => {
        let value = input.value.trim();
        if (!value && input.name === 'filter.v.availability') {
          const label = input.closest('label')?.textContent.toLowerCase().replace(/\s+/g, ' ') || '';
          value = label.includes('out of stock') ? '0' : label.includes('in stock') ? '1' : '';
        }
        if (value) url.searchParams.append(input.name, value);
      });
    }

    url.searchParams.delete('page');
    if (activeTaxonomyContext) url.searchParams.set('collection_context', activeTaxonomyContext);
    const sort = drawer.querySelector('#SortBy-mobile') || document.querySelector('#SortBy-mobile');
    url.searchParams.set('sort_by', sort?.value || 'best-selling');
    return url;
  };

  let cleanFilterUrlTimer = 0;
  const scheduleCleanEmptyFilterParams = () => {
    window.clearTimeout(cleanFilterUrlTimer);
    cleanFilterUrlTimer = window.setTimeout(() => {
      cleanFilterUrlTimer = 0;
      cleanEmptyFilterParams();
    }, 120);
  };

  const navigateMobileFacets = (drawer, clearLink = null) => {
    const url = mobileFacetUrl(drawer, clearLink);
    closeMobileFacetSheet();
    delete document.documentElement.dataset.athFacetApplyPending;
    window.location.assign(url.toString());
  };

  const installBlankFilterGuard = () => {
    if (document.documentElement.dataset.athBlankFilterGuard === 'true') return;
    document.documentElement.dataset.athBlankFilterGuard = 'true';

    document.addEventListener('input', (event) => {
      if (event.target.matches('#SortBy, #SortBy-mobile, [name^="filter."]')) {
        scheduleCleanEmptyFilterParams();
      }

      if (event.target.matches('.mobile-facets__checkbox[name^="filter."]')) {
        const drawer = event.target.closest('menu-drawer.mobile-facets__wrapper');
        const clearButton = drawer?.querySelector('.mobile-facets__main > .mobile-facets__footer .mobile-facets__clear');
        if (clearButton) clearButton.hidden = !drawer.querySelector('input[name^="filter."]:checked');
        return;
      }

      if (!event.target.matches('#SortBy, #SortBy-mobile')) return;

      const form = event.target.closest('form');
      const blankFilters = [...(form?.elements || [])].filter((field) =>
        field.name?.startsWith('filter.') && field.value.trim() === '' && !field.disabled
      );

      blankFilters.forEach((field) => { field.disabled = true; });
      setTimeout(() => blankFilters.forEach((field) => { field.disabled = false; }), 0);
    }, true);

    document.addEventListener('click', (event) => {
      const drawer = event.target.closest?.('menu-drawer.mobile-facets__wrapper');
      if (!drawer) return;

      const clear = event.target.closest?.('.mobile-facets__clear');
      if (clear) {
        event.preventDefault();
        event.stopPropagation();
        navigateMobileFacets(drawer, clear);
        return;
      }

      if (!event.target.closest?.('.mobile-facets__footer .button')) return;
      event.preventDefault();
      event.stopPropagation();
      navigateMobileFacets(drawer);
    }, true);

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (!document.querySelector('menu-drawer.mobile-facets__wrapper > details[open]')) return;
      event.preventDefault();
      closeMobileFacetSheet();
      document.querySelector('menu-drawer.mobile-facets__wrapper > details > summary')?.focus({ preventScroll: true });
    });
  };

  const cleanEmptyFilterParams = () => {
    const url = new URL(window.location.href);
    let changed = false;

    [...url.searchParams.entries()].forEach(([key, value]) => {
      if (key.startsWith('filter.') && value === '') {
        url.searchParams.delete(key);
        changed = true;
      }
    });

    const contextValues = url.searchParams.getAll('collection_context').filter(Boolean);
    if (contextValues.length > 1) {
      url.searchParams.delete('collection_context');
      url.searchParams.set('collection_context', contextValues[0]);
      changed = true;
    }

    const normalizedQuery = url.searchParams.toString();
    const normalizedUrl = `${url.pathname}${normalizedQuery ? `?${normalizedQuery}` : ''}${url.hash}`;
    const currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    if (changed || normalizedUrl !== currentUrl) {
      window.history.replaceState(window.history.state, '', normalizedUrl);
    }
  };

  const repairMobileAvailabilityValues = (scope = document) => {
    const inputs = scope.querySelectorAll?.('.mobile-facets__checkbox[name="filter.v.availability"]') || [];
    inputs.forEach((input) => {
      const label = input.closest('label')?.textContent.toLowerCase().replace(/\s+/g, ' ') || '';
      const expected = label.includes('out of stock') ? '0' : label.includes('in stock') ? '1' : '';
      if (!expected) return;
      if (input.getAttribute('value') !== expected) input.setAttribute('value', expected);
    });
  };

  const enhanceCards = (scope = document) => {
    scope.querySelectorAll('#product-grid .card-wrapper').forEach((card) => {
      const productLink = card.querySelector('.card__heading a[href*="/products/"]');
      if (productLink && !productLink.hasAttribute('title')) productLink.title = productLink.textContent.trim();
      const handle = productLink ? handleFromHref(productLink.href) : '';
      const curated = imageMap.get(handle);
      const image = card.querySelector('.card__media img');

      if (curated && image && image.dataset.athCuratedImage !== curated.src) {
        image.src = withWidth(curated.src, 480);
        image.srcset = [240, 360, 480, 640].map((width) => `${withWidth(curated.src, width)} ${width}w`).join(', ');
        image.sizes = '(min-width: 1440px) 205px, (min-width: 1200px) 25vw, (min-width: 900px) 33vw, 50vw';
        image.alt = curated.alt;
        image.dataset.athCuratedImage = curated.src;
      }

      const productCard = card.querySelector('.card');
      const soldOut = [...card.querySelectorAll('.badge')].some((badge) => /sold out/i.test(badge.textContent));
      let shipping = productCard?.querySelector('[data-ath-card-shipping]');
      if (productCard && !shipping) {
        shipping = document.createElement('p');
        shipping.className = 'ath-product-card__shipping';
        shipping.dataset.athCardShipping = '';
        productCard.append(shipping);
      }
      if (shipping) {
        shipping.classList.toggle('ath-product-card__shipping--placeholder', soldOut);
        const shippingCopy = 'Fast & free shipping on orders $100+';
        if (shipping.textContent !== shippingCopy) shipping.textContent = shippingCopy;
        if (soldOut) shipping.setAttribute('aria-hidden', 'true');
        else shipping.removeAttribute('aria-hidden');
      }

      const information = card.querySelector('.card > .card__content > .card__information');
      if (information && productLink && !information.querySelector('[data-ath-card-cta]')) {
        const cta = document.createElement('a');
        cta.className = 'ath-product-card__cta';
        cta.dataset.athCardCta = '';
        cta.href = productLink.href;
        cta.textContent = 'View options';
        cta.setAttribute('aria-label', `View options for ${productLink.textContent.trim()}`);
        information.append(cta);
      }
    });
  };

  const enhanceMobileToolbar = (scope = document) => {
    const container = scope.querySelector?.('.facets-container') || document.querySelector('.facets-container');
    if (!container) return;

    container.querySelectorAll('.mobile-facets__open-label.medium-hide').forEach((label) => {
      if (label.textContent.trim() !== 'Filters') label.textContent = 'Filters';
    });
    container.querySelectorAll('.mobile-facets__heading.medium-hide').forEach((heading) => {
      if (heading.textContent.trim() !== 'Filters') heading.textContent = 'Filters';
    });

    const drawer = container.querySelector('menu-drawer.mobile-facets__wrapper');
    const nativeSort = container.querySelector('#SortBy-mobile');
    if (!drawer || !nativeSort) return;

    const mobileMain = drawer.querySelector('.mobile-facets__main');
    if (mobileMain && !mobileMain.querySelector('[data-ath-mobile-facet-navigation]')) {
      const navigation = document.createElement('div');
      navigation.className = 'ath-mobile-facet-navigation';
      navigation.dataset.athMobileFacetNavigation = '';

      [
        ['Browse categories', primaryCategoryLinks],
        ['Shop by brand', brandLinks]
      ].filter(([, links]) => links.length).forEach(([title, links]) => {
        const group = document.createElement('section');
        const toggle = document.createElement('button');
        const list = document.createElement('ul');
        const groupId = `AthMobileFacet-${title.toLowerCase().replace(/[^a-z]+/g, '-')}`;
        group.className = 'ath-mobile-facet-navigation__group';
        toggle.type = 'button';
        toggle.className = 'ath-mobile-facet-navigation__toggle';
        toggle.textContent = title;
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-controls', groupId);
        list.id = groupId;
        list.hidden = true;
        links.forEach(([label, href, active]) => {
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = href;
          link.textContent = label;
          if (active) link.setAttribute('aria-current', 'page');
          item.append(link);
          list.append(item);
        });
        toggle.addEventListener('click', () => {
          const expanded = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', String(!expanded));
          list.hidden = expanded;
        });
        group.append(toggle, list);
        navigation.append(group);
      });

      const firstNativeFacet = mobileMain.querySelector(':scope > details');
      const availabilityHeading = document.createElement('p');
      availabilityHeading.className = 'ath-mobile-facet-availability-heading';
      availabilityHeading.textContent = 'Availability';
      const navigationHeading = document.createElement('p');
      navigationHeading.className = 'ath-mobile-facet-navigation-heading';
      navigationHeading.textContent = 'Browse instead';
      if (firstNativeFacet) {
        firstNativeFacet.insertAdjacentElement('beforebegin', availabilityHeading);
        firstNativeFacet.insertAdjacentElement('afterend', navigationHeading);
        navigationHeading.insertAdjacentElement('afterend', navigation);
      } else {
        mobileMain.prepend(availabilityHeading, navigationHeading, navigation);
      }
    }

    const mobileHeader = drawer.querySelector('.mobile-facets__header');
    const nativeCloseButton = drawer.querySelector('.mobile-facets__close');
    nativeCloseButton?.remove();
    if (mobileHeader && !mobileHeader.querySelector('[data-ath-mobile-sheet-close]')) {
      const closeButton = document.createElement('button');
      closeButton.type = 'button';
      closeButton.className = 'ath-mobile-sheet-close';
      closeButton.dataset.athMobileSheetClose = '';
      closeButton.setAttribute('aria-label', 'Close filters');
      closeButton.innerHTML = '<span aria-hidden="true"></span>';
      closeButton.addEventListener('click', closeMobileFacetSheet);
      mobileHeader.append(closeButton);
    }

    const drawerDetails = drawer.querySelector('details');
    const drawerSummary = drawerDetails?.querySelector(':scope > summary');
    if (drawerDetails && drawerSummary && !drawerDetails.dataset.athA11ySynced) {
      const syncExpandedState = () => {
        drawerSummary.setAttribute('aria-expanded', String(drawerDetails.open));
        setMobileFacetScrollLock(drawerDetails.open);
        if (!drawerDetails.open) return;
        repairMobileAvailabilityValues(drawer);
        const availability = drawer.querySelector('.mobile-facets__main > details');
        if (availability) {
          availability.open = true;
          availability.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'true');
        }
      };
      drawerDetails.dataset.athA11ySynced = '';
      drawerDetails.addEventListener('toggle', syncExpandedState);
      syncExpandedState();
    }

    const clearButton = drawer.querySelector('.mobile-facets__main > .mobile-facets__footer .mobile-facets__clear');
    if (clearButton) {
      clearButton.hidden = !drawer.querySelector('input[name^="filter."]:checked');
    }

    let control = container.querySelector('[data-ath-mobile-sort]');
    if (!control) {
      control = document.createElement('label');
      control.className = 'ath-mobile-sort medium-hide large-up-hide';
      control.dataset.athMobileSort = '';
      control.innerHTML = '<span class="visually-hidden">Sort products</span><span class="ath-mobile-sort__label" aria-hidden="true">Sort by</span><select aria-label="Sort products"></select><span class="ath-mobile-sort__caret" aria-hidden="true"></span>';
      drawer.insertAdjacentElement('afterend', control);

      control.querySelector('select').addEventListener('change', (event) => {
        const currentNativeSort = document.querySelector('.facets-container #SortBy-mobile');
        if (!currentNativeSort || currentNativeSort.value === event.target.value) return;
        currentNativeSort.value = event.target.value;
        currentNativeSort.dispatchEvent(new Event('input', { bubbles: true }));
      });
    }

    const visibleSort = control.querySelector('select');
    const signature = [...nativeSort.options].map((option) => `${option.value}:${option.textContent.trim()}`).join('|');
    if (visibleSort.dataset.options !== signature) {
      visibleSort.replaceChildren(...[...nativeSort.options].map((option) => option.cloneNode(true)));
      visibleSort.dataset.options = signature;
    }
    visibleSort.value = nativeSort.value;
  };

  const simplifySortOptions = () => {
    document.querySelectorAll('#SortBy, #SortBy-mobile').forEach((select) => {
      [...select.options].forEach((option) => {
        const preferredLabel = preferredSortOptions.get(option.value);
        if (!preferredLabel && !option.selected) {
          option.remove();
          return;
        }
        if (preferredLabel && option.textContent.trim() !== preferredLabel) option.textContent = preferredLabel;
      });
    });
  };

  const enhanceLongFacets = () => {
    document.querySelectorAll('#FacetsWrapperDesktop .facets__disclosure-vertical').forEach((facet) => {
      const list = facet.querySelector('.facets__list--vertical');
      const items = list ? [...list.querySelectorAll(':scope > li')] : [];
      if (!list || items.length <= 5 || facet.querySelector('[data-ath-facet-search]')) return;

      const facetName = facet.querySelector('.facets__summary-label, summary span')?.textContent.trim().replace(/\s*\(\d+\)\s*$/, '') || 'filter';
      const search = document.createElement('label');
      search.className = 'ath-facet-search';
      search.dataset.athFacetSearch = '';
      search.innerHTML = `<span class="visually-hidden">Search ${facetName}</span><input type="search" autocomplete="off" placeholder="Search ${facetName.toLowerCase()}" aria-label="Search ${facetName}"><span aria-hidden="true">⌕</span>`;
      list.insertAdjacentElement('beforebegin', search);

      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'ath-facet-more';
      toggle.textContent = `Show ${items.length - 5} more`;
      list.insertAdjacentElement('afterend', toggle);

      let expanded = false;
      const refresh = () => {
        const query = search.querySelector('input').value.trim().toLowerCase();
        items.forEach((item, index) => {
          const matches = !query || item.textContent.toLowerCase().includes(query);
          item.hidden = !matches || (!query && !expanded && index >= 5);
        });
        toggle.hidden = Boolean(query);
        toggle.textContent = expanded ? 'Show less' : `Show ${items.length - 5} more`;
        toggle.setAttribute('aria-expanded', String(expanded));
      };

      search.querySelector('input').addEventListener('input', refresh);
      toggle.addEventListener('click', () => {
        expanded = !expanded;
        refresh();
      });
      refresh();
    });
  };

  const removePriceFacets = (scope = document) => {
    const details = scope.querySelectorAll?.('#FacetsWrapperDesktop details, .mobile-facets__main details') || [];
    details.forEach((facet) => {
      const label = facet.querySelector('summary')?.textContent.trim().replace(/\s+/g, ' ') || '';
      if (/^Price\b/i.test(label)) facet.remove();
    });
  };

  const enhanceDesktopRail = (scope = document) => {
    const wrapper = scope.querySelector?.('#FacetsWrapperDesktop') || document.querySelector('#FacetsWrapperDesktop');
    if (!wrapper) return;
    wrapper.classList.toggle(
      'ath-has-active-filters',
      Boolean(wrapper.querySelector('.active-facets__button:not(.active-facets__button-remove)'))
    );
    if (!wrapper.querySelector('[data-ath-facet-categories]')) {
      const collectionTitle = document.querySelector('[data-ath-collection-title]')?.dataset.athCollectionTitle || 'this category';
      const nav = document.createElement('nav');
      nav.className = 'ath-facet-categories';
      nav.dataset.athFacetCategories = '';
      nav.setAttribute('aria-label', `Browse categories related to ${collectionTitle}`);
      nav.innerHTML = '<details open><summary>Categories</summary><ul></ul></details>';

      const list = nav.querySelector('ul');
      primaryCategoryLinks.forEach(([label, href, active]) => {
        const item = document.createElement('li');
        item.className = 'ath-facet-categories__primary';
        const link = document.createElement('a');
        link.href = href;
        link.textContent = label;
        if (active) link.setAttribute('aria-current', 'page');
        item.append(link);
        list.append(item);
      });

      const visibleChildLinks = childLinks.filter(([, href]) => (
        new URL(href, window.location.origin).pathname !== window.location.pathname
      ));
      if (visibleChildLinks.length) {
        const divider = document.createElement('li');
        divider.className = 'ath-facet-categories__subheading';
        divider.textContent = currentTaxonomy.childLabel;
        list.append(divider);
      }

      visibleChildLinks.forEach(([label, href]) => {
        const item = document.createElement('li');
        item.className = 'ath-facet-categories__child';
        const link = document.createElement('a');
        link.href = href;
        link.textContent = label;
        if (new URL(href, window.location.origin).pathname === window.location.pathname) link.setAttribute('aria-current', 'page');
        item.append(link);
        list.append(item);
      });

      const activeFacets = wrapper.querySelector('.active-facets-desktop');
      activeFacets?.insertAdjacentElement('afterend', nav);
    }

    if (brandLinks.length && !wrapper.querySelector('[data-ath-facet-brands]')) {
      const nav = document.createElement('nav');
      nav.className = 'ath-facet-categories ath-facet-brands';
      nav.dataset.athFacetBrands = '';
      nav.setAttribute('aria-label', 'Shop by brand');
      nav.innerHTML = '<details open><summary>Shop by brand</summary><ul></ul></details>';

      const list = nav.querySelector('ul');
      brandLinks.forEach(([label, href]) => {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = href;
        link.textContent = label;
        item.append(link);
        list.append(item);
      });
      wrapper.append(nav);
    }
  };

  const enhanceDesktopToolbar = () => {
    const form = document.querySelector('#FacetSortForm');
    const count = form?.querySelector('.product-count-vertical');
    if (!form || !count) return;
    count.setAttribute('aria-label', 'Product results');
  };

  const enhanceCollectionState = () => {
    const state = document.querySelector('[data-ath-collection-product-count]');
    if (!state) return;
    const productCount = Number(state.dataset.athCollectionProductCount);
    const isEmpty = Number.isFinite(productCount) && productCount === 0;
    const isSparseRoot = state.dataset.athCollectionSparseRoot === 'true' && productCount <= 1;
    const grid = document.querySelector('#ProductGridContainer');
    const productSection = grid?.closest('.shopify-section') || grid?.parentElement;

    document.documentElement.classList.toggle('ath-collection-is-empty', isEmpty);
    document.documentElement.classList.toggle('ath-collection-is-sparse', isSparseRoot);
    productSection?.classList.toggle('ath-collection-product-section--hidden', isEmpty);
  };

  const enhanceCollection = (scope = document) => {
    installCollectionLinkSortGuard();
    installBlankFilterGuard();
    cleanEmptyFilterParams();
    ensureTaxonomyContextInputs(scope);
    repairMobileAvailabilityValues(document);
    simplifySortOptions(scope);
    removePriceFacets(scope);
    enhanceCards(scope);
    enhanceMobileToolbar(scope);
    enhanceDesktopRail(scope);
    enhanceLongFacets(scope);
    enhanceDesktopToolbar();
    enhanceCollectionState();
    const heading = scope.querySelector?.('.facets__heading--vertical') || document.querySelector('.facets__heading--vertical');
    if (heading && heading.textContent.trim() !== 'Filters') heading.replaceChildren('Filters');
  };

  enhanceCollection();

  const productGridContainer = document.querySelector('#ProductGridContainer');
  if (!productGridContainer) return;

  const filters = document.querySelector('#main-collection-filters');
  const mutationTargets = [productGridContainer, filters].filter(Boolean);
  const observerOptions = { childList: true, subtree: true };
  let updateFrame = 0;
  const collectionObserver = new MutationObserver(() => {
    if (updateFrame) return;
    updateFrame = window.requestAnimationFrame(() => {
      updateFrame = 0;
      collectionObserver.disconnect();
      enhanceCollection(document);
      mutationTargets.filter((target) => target.isConnected).forEach((target) => {
        collectionObserver.observe(target, observerOptions);
      });
    });
  });
  mutationTargets.forEach((target) => collectionObserver.observe(target, observerOptions));

  document.addEventListener('shopify:section:unload', () => {
    window.cancelAnimationFrame(updateFrame);
    window.clearTimeout(cleanFilterUrlTimer);
    collectionObserver.disconnect();
  }, { once: true });

})();
